import LaunchIcon from '@material-ui/icons/Launch'
import { useAdaChat } from 'hooks/useAdaChat'
import AdaIcon from 'layout/widgets/adaChat/AdaIcon'
import { useAdaActive } from 'layout/widgets/adaChat/useAdaActive'
import { styled } from 'opensolar-ui'
import React from 'react'
import { useTranslate } from 'react-admin'

export const AdaIconWrapper = styled('span')`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`

export const AdaButtonLink = styled('button')`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: #4272dd;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: color 0.2s ease;
  font-family: inherit;

  &:hover {
    color: #3a5bb8;
    text-decoration: underline;
  }

  &:active {
    color: #2d4a94;
  }

  &:focus {
    outline: none;
    text-decoration: underline;
  }
`

export const AdaLinkButton = styled('a')`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: #666666;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: color 0.2s ease;
  font-family: inherit;

  &:hover {
    color: #4272dd;
    text-decoration: underline;
  }

  &:active {
    color: #3a5bb8;
  }

  &:focus {
    outline: none;
    text-decoration: underline;
  }
`

interface UseAdaActionsProps {
  adaQuestion?: string
  linkUrl?: string
}

export const useAdaActions = ({ adaQuestion, linkUrl }: UseAdaActionsProps) => {
  const { askAda } = useAdaChat()
  const { textActive } = useAdaActive()
  const translate = useTranslate()

  const handleAskAda = (e?: React.MouseEvent) => {
    if (e) {
      e.stopPropagation()
    }
    if (!adaQuestion || !textActive) return
    askAda(adaQuestion)
  }

  const handleOpenLink = (e?: React.MouseEvent) => {
    if (e) {
      e.stopPropagation()
    }
    if (linkUrl) {
      window.open(linkUrl, '_blank', 'noopener,noreferrer')
    }
  }

  return {
    textActive,
    handleAskAda,
    handleOpenLink,
    translate,
  }
}

interface AdaAskButtonProps {
  onClick: (e: React.MouseEvent) => void
  iconSize?: number
}

export const AdaAskButton: React.FC<AdaAskButtonProps> = ({ onClick, iconSize = 14 }) => {
  const translate = useTranslate()
  return (
    <AdaButtonLink onClick={onClick} type="button">
      <AdaIconWrapper>
        <AdaIcon size={iconSize} />
      </AdaIconWrapper>
      {translate('Ask Ada')}
    </AdaButtonLink>
  )
}

interface AdaOpenLinkButtonProps {
  href: string
  onClick: (e: React.MouseEvent) => void
  iconSize?: number
}

export const AdaOpenLinkButton: React.FC<AdaOpenLinkButtonProps> = ({ href, onClick, iconSize = 12 }) => {
  const translate = useTranslate()
  return (
    <AdaLinkButton href={href} target="_blank" rel="noopener noreferrer" onClick={onClick}>
      <LaunchIcon style={{ fontSize: iconSize }} />
      {translate('Open Link')}
    </AdaLinkButton>
  )
}
